import { ComponentType } from 'react';

export default <T extends {}>(hook: (props: T) => void) => (
  Component: ComponentType
) => (props: T) => {
  hook(props);
  return <Component {...props} />;
};
